import { useState } from "react";
import { Language, dictionary } from "../../../utils/dictionary";
import { EmbeddedSignupResult, useMetaSDK } from "../../../hooks/useMetaSDK";
import {
  ChannelIntegrationWizard,
  whatsappChannelConfig,
} from "../ChannelWizard";

interface ModalWhatsAppIntegrationProps {
  setModalOpen: (open: boolean) => void;
  handleOAuthComplete: (data: EmbeddedSignupResult) => void;
  loading: boolean;
  language: Language;
}

const ModalWhatsAppIntegration = ({
  setModalOpen,
  handleOAuthComplete,
  loading,
  language,
}: ModalWhatsAppIntegrationProps) => {
  const { sdkReady, launchWhatsAppEmbeddedSignup } = useMetaSDK();
  const [sdkLoading, setSdkLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConnect = async () => {
    setError(null);
    setSdkLoading(true);
    try {
      const result = await launchWhatsAppEmbeddedSignup();
      handleOAuthComplete(result);
    } catch (err: unknown) {
      console.error("Embedded signup failed:", err);
      setError(
        err instanceof Error
          ? err.message
          : dictionary["integration-error"]?.[language] || "Error connecting WhatsApp"
      );
    } finally {
      setSdkLoading(false);
    }
  };

  return (
    <ChannelIntegrationWizard
      config={whatsappChannelConfig}
      language={language}
      loading={loading || sdkLoading}
      sdkReady={sdkReady}
      error={error}
      onClose={() => setModalOpen(false)}
      onConnect={handleConnect}
    />
  );
};

export default ModalWhatsAppIntegration;
